/**
 * @desc getResource
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.UserResourceDto>;
export function request(body: defs.appCenter.LoginExchangeDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/load/resource`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
